import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { Button } from '../components/primitives';
import { Icon, ICON_DEFAULTS } from '../utils/icons';
import { useSiteSettings } from '../context/SiteSettingsContext';
import './About.css';

const About = () => {
  const { t } = useTranslation();
  const { returnsEnabled, returnsWindowDays, storeName } = useSiteSettings();

  return (
    <div className="about-page">
      <SEO title={t('about.title', `About ${storeName}`, { storeName })} description={t('about.lead')} />

      <header className="about-hero">
        <span className="about-eyebrow">{t('about.eyebrow')}</span>
        <h1 className="about-title">{t('about.title', `About ${storeName}`, { storeName })}</h1>
        <p className="about-lead">{t('about.lead')}</p>
      </header>

      <section className="about-section">
        <div className="about-section__icon" aria-hidden="true">
          <Icon.Star size={28} strokeWidth={ICON_DEFAULTS.strokeWidth} />
        </div>
        <div className="about-section__body">
          <h2>{t('about.section1.title')}</h2>
          <p>{t('about.section1.body')}</p>
        </div>
      </section>

      <section className="about-section">
        <div className="about-section__icon" aria-hidden="true">
          <Icon.Secure size={28} strokeWidth={ICON_DEFAULTS.strokeWidth} />
        </div>
        <div className="about-section__body">
          <h2>{t('about.section2.title')}</h2>
          <p>{t('about.section2.body')}</p>
        </div>
      </section>

      <section className="about-section">
        <div className="about-section__icon" aria-hidden="true">
          <Icon.Shipping size={28} strokeWidth={ICON_DEFAULTS.strokeWidth} />
        </div>
        <div className="about-section__body">
          <h2>{t('about.section3.title')}</h2>
          <p>{t('about.section3.body')}</p>
          {returnsEnabled && (
            <p>
              {t('about.section3.returns', {
                days: returnsWindowDays,
                defaultValue: `Returns within ${returnsWindowDays} days — no questions, no hassle.`,
              })}
            </p>
          )}
        </div>
      </section>

      <footer className="about-cta">
        <h2>{t('about.ctaTitle')}</h2>
        <div className="about-cta__actions">
          <Button as="link" to="/products" variant="brand" size="lg">
            {t('about.ctaButton')}
          </Button>
          <Button as="link" to="/contact" variant="secondary" size="lg">
            {t('about.ctaSecondary')}
          </Button>
        </div>
      </footer>
    </div>
  );
};

export default About;
